import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNotificationStore = defineStore('notification', () => {
    const message = ref('');
    const type = ref('info'); // 'success', 'error', 'info', etc.
    const visible = ref(false);
    const retryCallback = ref(null); // function to be triggered on retry

    const showMessage = (msg, msgType = 'info', retryFn = null) => {
        message.value = msg;
        type.value = msgType;
        retryCallback.value = retryFn;
        visible.value = true;

        // Optional auto-hide
        // setTimeout(() => { visible.value = false }, 5000);
    };

    const retry = () => {
        visible.value = false;
        if (retryCallback.value) retryCallback.value();
        retryCallback.value = null;
    };

    const hide = () => {
        visible.value = false;
        retryCallback.value = null;
    };

    return { message, type, visible, showMessage, retry, hide, retryCallback };
});
